<template>
  <v-container fluid>
    <v-form>
      <v-card>
        <v-card-text>
          <h4 class="primary--text">
            {{ $route.params.notificationTypeId ? "Edit" : "Create" }} Notification
            Type
          </h4>
        </v-card-text>
        <gru-form-base
          layout="column"
          :value="notificationType"
          :schema="mySchema"
          :doSubmit="doSubmit"
          :doBack="doBack"
        />
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { router } from "../../router";
import { mapState, mapGetters } from "vuex";
import { CrudService } from "@/services";
import { message } from "@/shared/message";

export default {
  name: "NotificationTypeEdit",
  data() {
    return {
      resource: "notificationType",
      notificationType: {
        id: 0,
        typetext: "",
        typevalue: "",
        typegetfield: ""
      },
    };
  },
  methods: {
    reloadNotificationItem(id) {
      if (id) {
        let vm = this;
        CrudService.of(this.resource)
            .getItem(id)
            .then(item => {
              vm.notificationType = item;
            });
      }
    },
    doSubmit() {
      if (this.$route.params.notificationId) {
        CrudService.of(this.resource)
          .updateItem(this.notificationType)
          .then(new_item => {
            message.success(
              this.$t("lang.common.update_success"),
              `/${this.resource}/edit/` + new_item.notificationTypeId
            );
            router.push(
              `/${this.resource}/`
            );
          });
      } else {
        CrudService.of(this.resource)
          .createItem(this.notificationType)
          .then(new_item => {
            message.success(
              this.$t("lang.common.add_success"),
              `/${this.resource}/edit/` + new_item.notificationTypeId
            );
            router.push(
              `/${this.resource}/`
            );
          });
      }
    },
    doBack() {
      router.push(
        `/${this.resource}/`
      );
    }
  },
  computed: {
    ...mapState({
      mySchema() {
        return {
          id: { type: "text", hidden: true },
          typetext: {
            type: "text",
            label: "lang.notification.newTypeName",
            validate: "required|max:50",
            focus: true
          },
          typevalue: {
            type: "text",
            label: "lang.notification.newTypeValue",
            validate: "required|max:255",
          },
          typegetfield: {
            type: "select",
            label: "lang.notification.newTypeGetField",
            validate: "required",
            items: this.$store.getters.userProperties
          }
        };
      },
      currentLang() {
        return this.$store.getters.selectedLocale.locale;
      },
      loading() {
        return this.$store.state.common.loading;
      },
      isEdited() {
        return (
          this.$route.params.templateId !== null &&
          this.$route.params.templateId !== undefined
        );
      },
      itemFields() {
        return [
          {
            value: "title" + this.selectedLocaleIndex,
            text: "lang.dashboard.title",
            columnType: "STRING",
            editable: true
          },
          {
            value: "contentTemplate",
            text: "lang.dashboard.contentTemplate",
            columnType: "STRING"
          },
          {
            value: "active",
            text: "lang.common.status",
            optionValues: this.allStateTypes,
            columnType: "BOOLEAN"
          }
        ];
      },
      templateFieldFields() {
        return [
          {
            value: "columnName",
            text: "lang.dashboard.fieldName",
            columnType: "STRING",
            editable: true
          },
          {
            value: "title" + this.selectedLocaleIndex,
            text: "lang.dashboard.title",
            columnType: "STRING"
          },
          {
            value: "columnType",
            text: "lang.dashboard.fieldType",
            columnType: "STRING"
          },
          {
            value: "controlType",
            text: "lang.dashboard.controlType",
            optionValues: this.allControlTypes,
            columnType: "STRING"
          },
          {
            value: "active",
            text: "lang.common.status",
            optionValues: this.allStateTypes,
            columnType: "BOOLEAN"
          }
        ];
      }
    }),
    ...mapGetters(["selectedLocaleIndex"])
  },
  mounted() {
  },
  created() {
    if (this.$route.params.notificationTypeId) {
      this.reloadNotificationItem(this.$route.params.notificationTypeId);
    } else {
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
  }
};
</script>
